/**
 * @generated SignedSource<<2088fd6a3a6f51be7dc93a1731ba6b12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PopupGroupForm_Query$variables = {};
export type PopupGroupForm_QueryVariables = PopupGroupForm_Query$variables;
export type PopupGroupForm_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PopupDistributionSettingFields_root">;
};
export type PopupGroupForm_QueryResponse = PopupGroupForm_Query$data;
export type PopupGroupForm_Query = {
  variables: PopupGroupForm_QueryVariables;
  response: PopupGroupForm_Query$data;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupGroupForm_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PopupDistributionSettingFields_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PopupGroupForm_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceConnection",
        "kind": "LinkedField",
        "name": "sources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Source",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73824a955432506f0941ccabf2002e99",
    "id": null,
    "metadata": {},
    "name": "PopupGroupForm_Query",
    "operationKind": "query",
    "text": "query PopupGroupForm_Query {\n  ...PopupDistributionSettingFields_root\n}\n\nfragment PopupDistributionSettingFields_root on Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};

(node as any).hash = "1573e832de1777688b34a3b208703a8c";

export default node;
